import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="py-16 text-center">
      <p className="text-lg font-semibold text-slate-800">{t('errors.notFound')}</p>
      <Link to="/" className="mt-4 inline-block font-semibold text-brand underline">{t('errors.home')}</Link>
    </div>
  );
}
